/**
 * ag-cart-keep-open.js · A Granel Madrid
 *
 * 1) Mantiene el cajón del carrito abierto al eliminar una línea.
 *
 * Por qué hace falta: al pulsar la papelera, el componente del carrito quita la
 * fila del DOM durante el propio despacho del clic. Cuando el evento llega al
 * listener de "clic fuera" de dialog.js, `dialog.contains(event.target)` ya es
 * false (el botón dejó de existir), así que lo toma por un clic en el backdrop
 * y llama a closeDialog().
 *
 * Solución: envolver closeDialog en la instancia del cajón e ignorar el cierre
 * durante una ventana muy corta después de pulsar eliminar. Si la línea
 * eliminada era la última, no se pone guarda: el cajón se cierra como antes.
 *
 * 2) CA-B3 · Cantidad optimista (Claude, 30/09/2026, TIENDA-TOP §7.11). Al pulsar «+», «−», escribir la
 *    cantidad o borrar una línea, el importe de la línea, el subtotal, el envío, el total estimado, la frase
 *    de envío y el botón se actualizan al instante con la aritmética local. Horizon (component-cart-items.js,
 *    sin tocar) confirma con /cart/change.js y vuelve a pintar la sección; si la petición falla (no llega el
 *    cart:update de cart-items-component antes de que la cesta deje de estar ocupada), se restaura lo pintado.
 *    Ronda 1 de QA (30/09): los importes se cambian en el nodo de texto que ya existe (Text.data), sin sustituir
 *    nodos. Sustituirlos (textContent o innerHTML) dispara la invalidación de las ~280 reglas :has() del tema y
 *    recalcula el estilo de ~700 elementos: 75-130 ms por clic con la CPU a x4. Cambiando el texto en su sitio,
 *    1-2 ms (medido con carrito/r1/coste-r1.mjs).
 *
 * 3) CA-B4 · «¿Llega a tu casa?»: el código postal se comprueba aquí, en el navegador. No se envía ni se guarda.
 *
 * 4) QA 2 · Al cerrar el cajón (✕, Escape, velo o «Atrás»), la página vuelve a donde estaba (antes, en móvil, a 0).
 * 5) QA 2 · Escape con el foco fuera del cajón (tras borrar una línea) ya no deja la página fija; el foco
 *    perdido al borrar vuelve a la papelera de la línea siguiente.
 */
(function () {
  if (window.__agCartKeepOpen) return;
  window.__agCartKeepOpen = true;

  var GUARD_MS = 1200;
  var guardUntil = 0;

  /* 4) QA 2 (H-02, 30/09) · Al cerrar el cajón, la página vuelve a donde estaba.
   *    dialog.js fija el body (top:-Ypx) al abrir y al cerrar hace scrollTo(Y), pero en móvil (<750 px)
   *    cart-drawer.js hace history.back() tras cerrar: el popstate restaura el scroll que el navegador
   *    guardó al hacer pushState con el body ya fijo, que es 0. Medido: 1.500 → 0 con ✕, Escape y «Atrás».
   *    Aquí se guarda Y antes de cerrar y se vuelve a él al terminar (y otra vez tras ese popstate).
   *    Sin tocar dialog.js ni cart-drawer.js. */
  function posicionBloqueada() {
    var t = parseInt(document.body.style.top, 10);
    if (document.body.style.position === 'fixed' && !isNaN(t)) return -t;
    return window.scrollY;
  }
  function volverA(y, esperarPop) {
    if (!(y > 0)) return;
    var ir = function () {
      if (document.querySelector('cart-drawer-component dialog[open]')) return; // se ha vuelto a abrir
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo({ top: y, behavior: 'instant' });
    };
    requestAnimationFrame(ir);
    if (!esperarPop) return;
    var quitar = function () { clearTimeout(tope); window.removeEventListener('popstate', alPop); };
    // El navegador restaura su posición después de despachar popstate: se corrige en el fotograma siguiente.
    var alPop = function () { quitar(); requestAnimationFrame(function () { ir(); requestAnimationFrame(ir); }); };
    var tope = setTimeout(quitar, 1500);
    window.addEventListener('popstate', alPop);
  }

  function patch(comp) {
    if (comp.__agPatched) return;
    if (typeof comp.closeDialog !== 'function') return; // aún sin actualizar: se reintenta al abrir
    comp.__agPatched = true;

    // 1) Cierre por closeDialog() (el "clic fuera" de dialog.js pasa por aquí) + 4) posición de scroll.
    var original = comp.closeDialog;
    comp.closeDialog = function () {
      if (Date.now() < guardUntil) return Promise.resolve(); // cierre colateral del borrado
      var dlg = comp.querySelector('dialog');
      if (!dlg || !dlg.open) return original.apply(this, arguments);
      var y = posicionBloqueada();
      var conHistorial = !!(history.state && history.state.cartDrawerOpen);
      var r = original.apply(this, arguments);
      Promise.resolve(r).then(function () { volverA(y, conHistorial); }, function () {});
      return r;
    };

    // 2) Cierre por pérdida del atributo `open` (re-render del carrito).
    var dialog = comp.querySelector('dialog');
    if (!dialog) return;
    new MutationObserver(function () {
      if (Date.now() >= guardUntil) return;
      if (dialog.open) return;
      try {
        dialog.showModal();
      } catch (e) {}
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  // pointerdown, no click: Horizon detiene la propagación del click de la
  // papelera, así que un listener de click nunca llega a ejecutarse.
  function onPointerDown(e) {
    {
      var target = e.target;
      if (!target || !target.closest) return;

      // La cruz debe cerrar siempre, aunque coincida con la ventana de guarda.
      if (target.closest('.cart-drawer__close-button')) {
        guardUntil = 0;
        return;
      }

      var btn = target.closest('.cart-items__remove');
      if (!btn) return;

      var comp = btn.closest('cart-drawer-component');
      if (!comp) return;

      var lines = comp.querySelectorAll('.cart-items__remove').length;

      // Última línea: dejar que el cajón se cierre solo.
      if (lines <= 1) return;

      patch(comp);
      guardUntil = Date.now() + GUARD_MS;
    }
  }

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('mousedown', onPointerDown, true);

  // Se envuelve cada cajón en cuanto existe (antes solo al pulsar la papelera): el cierre necesita el
  // envoltorio desde la primera apertura. dialog:open no burbujea, pero la fase de captura lo ve.
  function patchAll() { document.querySelectorAll('cart-drawer-component').forEach(patch); }
  if (window.customElements) customElements.whenDefined('cart-drawer-component').then(patchAll);
  document.addEventListener('dialog:open', function (e) {
    var t = e.target;
    if (t && t.tagName === 'CART-DRAWER-COMPONENT') patch(t);
  }, true);

  /* 5) QA 2 (ronda 2, 30/09) · Escape con el foco fuera del cajón. Tras borrar una línea, el botón ya no
   *    existe y el foco cae en <body>: el keydown no llega al componente (dialog.js escucha en él), el <dialog>
   *    se cierra solo (cancel nativo) y nadie suelta el body: la página se quedaba fija (position:fixed,
   *    top:-1200px) y sin scroll. Medido a 390 y 1440. Aquí ese Escape se lleva al cierre de Horizon. */
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      guardUntil = 0;
      var d = document.querySelector('cart-drawer-component dialog[open]');
      var comp = d && d.closest('cart-drawer-component');
      if (!comp || comp.contains(e.target)) return; // dentro del cajón lo gestiona dialog.js
      patch(comp);
      if (typeof comp.closeDialog !== 'function') return;
      e.preventDefault(); // sin cancel nativo
      comp.closeDialog();
    },
    true
  );

  // Red de seguridad: si el <dialog> del cajón se cierra por cualquier otra vía nativa con el body aún fijo,
  // se suelta el body, se vuelve a la posición y se deshace la entrada de historial del cajón (móvil).
  document.addEventListener(
    'close',
    function (e) {
      var d = e.target;
      if (!d || d.tagName !== 'DIALOG' || !d.closest || !d.closest('cart-drawer-component')) return;
      if (Date.now() < guardUntil) return; // cierre colateral del borrado: se reabre arriba
      var b = document.body.style;
      if (b.position !== 'fixed' || document.querySelector('dialog[open]')) return; // camino normal u otro modal
      var y = posicionBloqueada();
      var conHistorial = !!(history.state && history.state.cartDrawerOpen);
      b.width = '';
      b.position = '';
      b.top = '';
      d.classList.remove('dialog-closing');
      window.scrollTo({ top: y, behavior: 'instant' });
      if (conHistorial) history.back();
      volverA(y, conHistorial);
    },
    true
  );

  /* ------------------------------------------------------------------
   * 2) CA-B3 · Cantidad optimista
   * ------------------------------------------------------------------ */
  var ENVIO = 395; // 3,95 € por debajo del umbral de envío gratis (igual que cart-summary.liquid)

  function eur(c) {
    if (window.agEnvio) return window.agEnvio.eur(c);
    return (Math.max(0, Math.round(c)) / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }
  // Cambia el texto sin sustituir nodos si el elemento solo tiene un nodo de texto (ver cabecera).
  function texto(el, t) {
    if (!el) return;
    var n = el.firstChild;
    if (n && n.nodeType === 3 && !n.nextSibling) { if (n.data !== t) n.data = t; return; }
    if (el.textContent !== t) el.textContent = t;
  }
  function atributo(el, a, v) { if (el && el.getAttribute(a) !== v) el.setAttribute(a, v); }
  function estadoDe(el, prefijo) {
    var k = ['vacia', 'minimo', 'envio', 'gratis'];
    for (var i = 0; i < k.length; i++) if (el.classList.contains(prefijo + k[i])) return k[i];
    return null;
  }

  // Estado pendiente por componente (cajón o /cart): lo pintado antes del primer cambio, para poder revertir.
  var pendientes = new WeakMap();

  function foto(comp) {
    var guardado = [];
    comp.querySelectorAll('[data-ag-cesta-pie], [data-ag-envio], [data-agfs], .cart-totals__container, .cart-items__price, .cart-items__unit-price-wrapper').forEach(function (el) {
      guardado.push({ el: el, html: el.innerHTML, cls: el.className, attrs: [].map.call(el.attributes, function (a) { return [a.name, a.value]; }) });
    });
    return guardado;
  }
  function restaurar(guardado) {
    guardado.forEach(function (g) {
      if (!g.el.isConnected) return;
      g.el.innerHTML = g.html;
      g.el.className = g.cls;
      g.attrs.forEach(function (a) { g.el.setAttribute(a[0], a[1]); });
    });
  }

  function pintar(comp, total, items) {
    var pie = comp.querySelector('[data-ag-cesta-pie]');
    var E = window.agEnvio;
    var MIN = E ? E.MIN : 1000, UMBRAL = E ? E.UMBRAL : 3500;
    var envio = total >= UMBRAL ? 0 : ENVIO;
    var bajoMin = items > 0 && total < MIN;
    if (pie) {
      atributo(pie, 'data-ag-total', String(total));
      atributo(pie, 'data-ag-items', String(items));
      if (pie.classList.contains('ag-cesta-pie--minimo') !== bajoMin) pie.classList.toggle('ag-cesta-pie--minimo', bajoMin);
      var valor = pie.querySelector('[data-ag-total-estimado]');
      if (valor) { texto(valor, eur(total + envio)); atributo(valor, 'value', eur(total + envio).replace(' ', ' ')); }
      texto(pie.querySelector('[data-ag-pie-nota]'), envio === 0 ? 'envío gratis' : 'envío incluido'); // el «·» lo pone el CSS
      var btn = pie.querySelector('.cart__checkout-button');
      if (btn) {
        if (btn.disabled !== bajoMin) btn.disabled = bajoMin;
        texto(btn.querySelector('.button-text'), bajoMin ? 'Pedido mínimo 10 €' : 'Ir a pagar');
      }
    }
    texto(comp.querySelector('[data-ag-subtotal]'), eur(total));
    texto(comp.querySelector('[data-ag-envio-coste]'), envio === 0 ? 'Gratis' : eur(envio));
    // Frase y barra del cajón
    var bloque = comp.querySelector('[data-ag-envio]');
    if (bloque && E) {
      var e = E.estado(total, items);
      var antes = estadoDe(bloque, 'agp-fship--');
      if (antes !== e) {
        ['vacia', 'minimo', 'envio', 'gratis'].forEach(function (k) { bloque.classList.toggle('agp-fship--' + k, k === e); });
        bloque.classList.toggle('agp-fship--done', e === 'gratis');
      }
      var msg = bloque.querySelector('[data-ag-envio-msg]');
      if (msg) { if (E.pintarFrase) E.pintarFrase(msg, antes, total, items); else msg.innerHTML = E.html(total, items); }
      var fill = bloque.querySelector('[data-ag-envio-fill]');
      if (fill) fill.style.width = E.pct(total) + '%';
    }
    // Barra de /cart (free-shipping-bar)
    if (typeof window.agfsRender === 'function') window.agfsRender(total, items);
  }

  function optimista(row, qtyNueva) {
    var comp = row.closest('cart-items-component');
    var pie = comp && comp.querySelector('[data-ag-cesta-pie]');
    if (!comp || !pie) return;
    var unidad = num(row.getAttribute('data-ag-unidad'));
    var lineaAntes = num(row.getAttribute('data-ag-linea'));
    var qtyAntes = unidad > 0 ? Math.round(lineaAntes / unidad) : 0;
    if (qtyNueva === qtyAntes) return;
    if (!pendientes.has(comp)) pendientes.set(comp, { foto: foto(comp), confirmado: false });
    var lineaNueva = unidad * qtyNueva;
    var delta = lineaNueva - lineaAntes;
    // Descuento de cesta (porcentaje): se aplica en proporción; el servidor da el importe exacto en ~1 s.
    var total = num(pie.getAttribute('data-ag-total'));
    var bruto = num(pie.getAttribute('data-ag-bruto'));
    var factor = bruto > 0 ? total / bruto : 1;
    var totalNuevo = Math.max(0, Math.round(total + delta * factor));
    var itemsNuevo = Math.max(0, num(pie.getAttribute('data-ag-items')) + (qtyNueva - qtyAntes));
    pie.setAttribute('data-ag-bruto', String(Math.max(0, bruto + delta)));
    row.setAttribute('data-ag-linea', String(lineaNueva));
    var precio = row.querySelector('.cart-items__price text-component');
    if (precio && qtyNueva > 0) { texto(precio, eur(lineaNueva)); atributo(precio, 'value', eur(lineaNueva).replace(' ', ' ')); }
    // «2 × 0,99 €»: se pinta ya (dentro de la ventana de la pulsación), así la confirmación no mueve la fila.
    // cart-products.liquid siempre pinta el <span>: aquí cambia su texto. Con 1 unidad lo oculta el envoltorio
    // (visually-hidden, 3 ms); «hidden» solo con rebaja: cambiar ese atributo cuesta ~90 ms con la CPU a x4.
    var ud = row.querySelector('.cart-items__unit-price-wrapper');
    if (ud && qtyNueva > 0) {
      var caja = ud.firstElementChild || ud;
      var n = caja.querySelector('.cart-items__unidades');
      if (qtyNueva > 1) {
        if (!n) { n = document.createElement('span'); n.className = 'cart-items__unidades'; n.setAttribute('aria-hidden', 'true'); caja.insertBefore(n, caja.firstChild); }
        texto(n, qtyNueva + ' × ');
        if (n.hidden) n.hidden = false;
        if (ud.classList.contains('visually-hidden')) ud.classList.remove('visually-hidden');
      } else if (n) {
        texto(n, '1 × ');
        if (caja.querySelector('s')) { if (!n.hidden) n.hidden = true; }
        else if (!ud.classList.contains('visually-hidden')) ud.classList.add('visually-hidden');
      }
    }
    pintar(comp, totalNuevo, itemsNuevo);
  }

  // «+», «−» y cantidad escrita: Horizon emite quantity-selector:update con la cantidad nueva.
  document.addEventListener('quantity-selector:update', function (ev) {
    var d = ev.detail || {};
    if (!d.cartLine || typeof d.quantity !== 'number') return;
    var row = ev.target && ev.target.closest && ev.target.closest('.cart-items__table-row');
    if (row) optimista(row, d.quantity);
  });
  // Papelera: línea a 0 (Horizon ya quita la fila; aquí, el total).
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('.cart-items__remove');
    if (!btn) return;
    var row = btn.closest('.cart-items__table-row');
    var comp = row && row.closest('cart-items-component');
    if (!comp || comp.querySelectorAll('tbody .cart-items__table-row').length <= 1) return; // la última: estado vacío de Horizon
    foco = { comp: comp, i: [].indexOf.call(comp.querySelectorAll('tbody .cart-items__table-row'), row) };
    optimista(row, 0);
  }, true);

  // Tras borrar una línea, el foco (que estaba en su papelera) cae en <body>: se deja en la papelera de la
  // línea que ocupa su sitio (o la anterior). Solo si el foco se ha perdido; sin desplazar la página.
  var foco = null;
  function enfocarTrasBorrar(f) {
    var a = document.activeElement;
    if (a && a !== document.body && a.isConnected) return;
    var filas = f.comp.querySelectorAll('tbody .cart-items__table-row:not(.removing)');
    var fila = filas[Math.min(f.i, filas.length - 1)];
    var destino = fila && fila.querySelector('.cart-items__remove');
    if (!destino) { var dlg = f.comp.closest('dialog'); destino = dlg && dlg.querySelector('.cart-drawer__close-button'); }
    if (destino) destino.focus({ preventScroll: true });
  }

  // Confirmación: Horizon emite cart:update (origen cart-items-component) y luego repinta la sección.
  document.addEventListener('cart:update', function (ev) {
    var comp = ev.target && ev.target.closest ? ev.target.closest('cart-items-component') : null;
    var p = comp && pendientes.get(comp);
    if (p) p.confirmado = true;
  }, true);
  // Si la cesta deja de estar ocupada sin confirmación (error o red), se restaura lo pintado antes.
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var comp = m.target;
      if (!(comp instanceof Element) || comp.tagName !== 'CART-ITEMS-COMPONENT') return;
      var antes = /(^|\s)cart-items-disabled(\s|$)/.test(m.oldValue || '');
      if (!antes || comp.classList.contains('cart-items-disabled')) return; // solo al terminar la petición
      if (foco && foco.comp === comp) {
        var f = foco;
        foco = null;
        // la fila borrada sale con una animación (Horizon): se espera a que termine
        setTimeout(function () { enfocarTrasBorrar(f); }, 450);
      }
      var p = pendientes.get(comp);
      if (!p) return;
      if (!p.confirmado) restaurar(p.foto);
      pendientes.delete(comp);
    });
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });

  /* ------------------------------------------------------------------
   * 3) CA-B4 · «¿Llega a tu casa?» (código postal de la Comunidad de Madrid: 28xxx)
   * ------------------------------------------------------------------ */
  function comprobarCP(caja) {
    var input = caja.querySelector('[data-ag-cp-input]');
    var res = caja.querySelector('[data-ag-cp-res]');
    if (!input || !res) return;
    var cp = (input.value || '').replace(/\D/g, '').slice(0, 5);
    input.value = cp;
    if (cp.length !== 5) {
      res.removeAttribute('data-ok');
      res.textContent = 'Escribe los 5 números de tu código postal.';
      return;
    }
    if (/^28\d{3}$/.test(cp)) {
      res.setAttribute('data-ok', 'si');
      res.textContent = 'Sí, te lo llevamos.';
    } else {
      res.setAttribute('data-ok', 'no');
      res.textContent = 'Solo repartimos en la Comunidad de Madrid.';
    }
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('[data-ag-cp-boton]');
    if (b) comprobarCP(b.closest('[data-ag-cp]'));
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var i = ev.target && ev.target.closest && ev.target.closest('[data-ag-cp-input]');
    if (!i) return;
    ev.preventDefault();
    comprobarCP(i.closest('[data-ag-cp]'));
  });
})();
